export default "__VITE_ASSET__DZqopkNP__"